<div class="layout-content" id="boardUsersDialog">
	<form (ngSubmit)="submit()" [formGroup]="addDeviceForm">
		<p-stepper [(activeStep)]="activeIndex">
			<p-stepperPanel>
				<ng-template pTemplate="header">
					<button pButton pRipple type="button" class="bg-transparent h-3rem" (click)="changeActiveTabClick(0)"
						[class]="getColorFirstTabCustom()">
						<div class="flex flex-row align-items-center justify-content-center">
							<i class="pi cm-devices text-2xl pr-2"></i>
							<label *ngIf="!onExtendedMobile()" class="font-medium text-lg">{{ 'AUTOMATION_CATEGORY' | translate
								}}</label>
						</div>
					</button>
				</ng-template>
				<ng-template pTemplate="content">
					<div class="grid flex w-full align-items-center justify-content-center py-3">
						<div *ngFor="let boardClass of boardClasses let i = index"
							[class]="onExtendedMobile() ? 'col-6 flex justify-content-center px-0' : underTablet() ? 'col-3 flex justify-content-center px-0' : 'col-2 flex justify-content-center px-0'">
							<button pButton pRipple type="button" label="{{ boardClass.BoardName | translate }}"
								(click)="setBoardClass(boardClass)"
								class="font-normal border-round flex flex-column text-lg w-10rem h-10rem mx-2 py-5 gap-3"
								[ngClass]="boardClassButtonColor(boardClass)">
								<i class="pi text-6xl cm-{{ boardClass.IconName }}"></i>
							</button>
						</div>
					</div>
					<div class="grid py-3">
						<div class="col-12" [ngClass]="customPaddingX()">
							<div class="flex justify-content-end">
								<p-button label="{{ 'NEXT' | translate }}" icon="pi cm-arrow-right" iconPos="right"
									severity="primary" (onClick)="goToIndexCheckandActive('next')" />
							</div>
						</div>
					</div>
				</ng-template>
			</p-stepperPanel>

			<p-stepperPanel>
				<ng-template pTemplate="header">
					<button pButton pRipple type="button" class="bg-transparent h-3rem" (click)="changeActiveTabClick(1)"
						[class]="getColorSecondTab()">
						<div class="flex flex-row align-items-center justify-content-center">
							<i class="pi cm-info text-2xl pr-2"></i>
							<label *ngIf="!onExtendedMobile()" class="font-medium text-lg">{{ 'DETAILS' | translate }}</label>
						</div>
					</button>
				</ng-template>

				<ng-template pTemplate="content">
					<div class="grid">
						<div class="col-12" *ngIf="!selectIO && !subGateway" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.selectedSeries, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.selectedSeries, 'label')">{{ 'SERIES' | translate }}
								</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.selectedSeries, 'borderInput')">
									<p-dropdown formControlName="selectedSeries" [options]="series"
										[ngClass]="dynamicInputTextWidth()" appendTo="body"
										styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
										placeholder="{{ 'SERIES' | translate }}" (onChange)="onSelectSeries()" [filter]="true">
									</p-dropdown>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.selectedSeries)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<div class="col-12" *ngIf="!selectIO && !subGateway" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.selectedModel, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.selectedModel, 'label')">{{ 'MODEL' | translate }}
								</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.selectedModel, 'borderInput')">
									<p-dropdown formControlName="selectedModel" [options]="filterModelsType"
										[ngClass]="dynamicInputTextWidth()" appendTo="body"
										styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
										placeholder="{{ 'MODEL' | translate }}" [optionLabel]="convertionModel"
										(onChange)="onSelectedModel()" [filter]="true">
									</p-dropdown>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.selectedModel)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<div class="col-12" *ngIf="subGateway" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.selectedBoard, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.selectedBoard, 'label')">{{ 'MODEL' | translate }}
								</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.selectedBoard, 'borderInput')">
									<p-dropdown formControlName="selectedBoard" [options]="filterModelsType"
										[ngClass]="dynamicInputTextWidth()" appendTo="body"
										styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
										placeholder="{{ 'MODEL' | translate }}" [optionLabel]="convertionModel"
										(onChange)="onSelectedModelGateway()" [filter]="true">
									</p-dropdown>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.selectedBoard)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<div class="col-12" *ngIf="!selectIO && !subGateway" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.selectedBoard, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.selectedBoard, 'label')">{{ 'BOARD_TYPE' | translate }}
								</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.selectedBoard, 'borderInput')">
									<p-dropdown formControlName="selectedBoard" [options]="filterBoards"
										[ngClass]="dynamicInputTextWidth()" appendTo="body"
										styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
										placeholder="{{ 'BOARD_TYPE' | translate }}" [optionLabel]="convertionBoard"
										(onChange)="onSelectedBoard()" [filter]="true">
									</p-dropdown>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.selectedBoard)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<!--<div class="col-12" *ngIf="subGateway">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.keyCode, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.keyCode, 'label')">{{ 'KEYCODE' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.keyCode, 'borderInput')">
									<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="inputKeyCode"
										formControlName="keyCode" autocomplete="device-name"
										placeholder="{{ 'KEYCODE' | translate }}" />
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.keyCode)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>-->
						<div class="col-12" *ngIf="model && model.CategoryId === 7" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.selectedPeriphNumber, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.selectedPeriphNumber, 'label')">{{ 'CRP_ADDRESS' | translate
									}}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.selectedPeriphNumber, 'borderInput')">
									<p-dropdown [options]="periphNumbers" [ngClass]="dynamicInputTextWidth()" appendTo="body"
										styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
										formControlName="selectedPeriphNumber" placeholder="{{ 'CRP_ADDRESS' | translate }}">
									</p-dropdown>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.selectedPeriphNumber)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<div class="col-12" *ngIf="model && model.CategoryId === 2" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.keyCode, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.keyCode, 'label')">{{ 'KEYCODE' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.keyCode, 'borderInput')">
									<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="inputKeyCode"
										formControlName="keyCode" autocomplete="device-name"
										placeholder="{{ 'KEYCODE' | translate }}" />
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.keyCode)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<div class="col-12" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.name, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.name, 'label')">{{ 'NAME' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.name, 'borderInput')">
									<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="device-add-input-name"
										formControlName="name" autocomplete="device-name" placeholder="{{ 'NAME' | translate }}"
										maxlength="26" />
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.name)" class="flex align-items-center text-50 pt-1"
								[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
						</div>
						<div class="col-12" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.description, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.description, 'label')">{{ 'DESCRIPTION' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.description, 'borderInput')">
									<input type="text" pInputText [ngClass]="dynamicInputTextWidth()"
										id="device-add-input-description" formControlName="description"
										autocomplete="device-inputDescription" placeholder="{{ 'DESCRIPTION' | translate }}"
										maxlength="25" />
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.description)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<div *ngIf="multiIO()" class="col-12" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.iconName, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.iconName, 'label')">{{ 'DEVICE_ICON' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.iconName, 'borderInput')">
									<p-dropdown [options]="icons" formControlName="iconName" optionValue="value"
										[ngClass]="dynamicInputTextWidth()"
										styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
										id="input-add-deviceicon-multiio">
										<ng-template let-icon pTemplate="selectedItem">
											<div class="flex align-items-center justify-content-center gap-2">
												<i class="pi text-3xl cm-{{icon.value}}"></i>
											</div>
										</ng-template>
										<ng-template let-icon pTemplate="item">
											<div class="flex align-items-center justify-content-center gap-2">
												<i class="pi text-3xl cm-{{icon.value}}"></i>
											</div>
										</ng-template>
									</p-dropdown>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.iconName)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<div [class]="col12Responsive()"
							*ngIf="parentInfo.AllowedInputs !== undefined && parentInfo.AllowedInputs.length > 0 && multiIO()">
							<p-panel styleClass="p-panel-whitebg">
								<ng-template pTemplate="header">
									<div class="flex align-items-center">
										<span class="font-semibold">{{ 'INPUTS' | translate }}</span>
									</div>
								</ng-template>
								<div>
									<ng-container formArrayName="inputPorts">
										<div class="flex align-items-center justify-content-around">
											<p-checkbox *ngFor="let input of parentInfo.AllowedInputs; let i=index;"
												[formControlName]="i" [binary]="true" label="{{ input }}"
												[class]="showErrorRequiredCheckBox(this.f.inputPorts)" class="ml-4 mb-2 md:mb-0">
											</p-checkbox>
										</div>
									</ng-container>
								</div>
							</p-panel>
							<small *ngIf="showErrorRequiredMessage(this.f.inputPorts)"
								class="flex align-items-center text-50 pt-1 justify-content-center text-center">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<div [class]="col12Responsive()"
							*ngIf="parentInfo.AllowedOutputs !== undefined && parentInfo.AllowedOutputs.length > 0 && multiIO()">
							<p-panel styleClass="p-panel-whitebg">
								<ng-template pTemplate="header">
									<div class="flex align-items-center">
										<span class="font-semibold">{{ 'OUTPUTS' | translate }}</span>
									</div>
								</ng-template>
								<div>
									<ng-container formArrayName="outputPorts">
										<div class="flex align-items-center justify-content-around">
											<p-checkbox *ngFor="let output of parentInfo.AllowedOutputs; let i=index;"
												[formControlName]="i" [binary]="true" label="{{ output }}"
												[class]="showErrorRequiredCheckBox(this.f.outputPorts)" class="ml-4 mb-2 md:mb-0">
											</p-checkbox>
										</div>
									</ng-container>
								</div>
							</p-panel>
							<small *ngIf="showErrorRequiredMessage(this.f.outputPorts)"
								class="flex align-items-center text-50 pt-1 justify-content-center text-center">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<div class="col-12" [ngClass]="customPaddingX()">
							<div class="flex justify-content-start">
								<p-button label="{{ 'BACK' | translate }}" icon="pi cm-arrow-left" severity="secondary"
									(onClick)="goToIndexCheckandActive('back')" />
							</div>
						</div>
					</div>
				</ng-template>
			</p-stepperPanel>

			<ng-template pTemplate="end">
				<div class="grid mt-2 mb-1 mx-1 flex justify-content-center align-items-center">
					<button *ngIf="enableConfirmButtons()" type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
						class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
					</button>
					<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
						class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
					</button>
				</div>
			</ng-template>
		</p-stepper>
	</form>
</div>